import { VehicleDetailsOutput } from './vehicle-details-output.model';


export class VehicleDetailsSelectByIdOutput implements IVehicleDetailsSelectByIdOutput {
    status!: number;
    message!: string;
    data!: VehicleDetailsOutput;

    constructor(data?: IVehicleDetailsSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? VehicleDetailsOutput.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleDetailsSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDetailsSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IVehicleDetailsSelectByIdOutput {
    status: number;
    message: string;
    data: VehicleDetailsOutput;
}

